import {ListItemViewModel} from "../../../infrastructure/models/list-item.view-model";

export class CompetitorPlayerStatsTabModel extends ListItemViewModel {
  constructor(model) {
    super(model);

    this.analyticName = model.analyticName;
  }
}
